import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { RequestTrailConfirmAPI, RequestTrial, User } from '../model/authentication-model';
import { Router } from '@angular/router';

@Injectable({
     providedIn: 'root'
})

export class AuthenticationService {
     token: string;
     short_name: string;
     orgId: string;
     org_name: string;
     user_id: string;
     errors = [];
     token_expires;
     username: string;
     gvaAdmin: boolean = false;
     private _user = new BehaviorSubject<User>(null);
     AWSurl = 'https://dev.usermanagement.gva.semgenome.com';

     constructor(private http: HttpClient, private router: Router) { }

     get userIsAuthenticated(): Observable<any> {
          return this._user.asObservable().pipe(
               map((user) => {
                    if (user) {
                         return !!user.token;
                    } else {
                         false;
                    }
               }
               )
          );
     }

     onLogin(username: string, password: string, flag=false) {
          const sess_id = JSON.parse(localStorage.getItem('user'))?.token;
          const result = this.login('auth-token/', {
               username: username,
               password: password,
               session_id: sess_id ? sess_id : '',
               application: 'GVA',
               flag: flag
          })
               .pipe(
                    tap((userData) => {
                         this.updateData(userData['session_id'],userData['short_name'], userData['org_id'], userData['user_id'],userData['org_name'], userData['username'],userData['gva_admin']);
                         this._user.next(
                              new User(this.username, this.token, this.token_expires, this.short_name, this.orgId, this.user_id, this.org_name)
                         );
                         this.storeAuthData(this.username, this.token, this.token_expires, this.short_name, this.orgId, this.user_id, this.org_name, this.gvaAdmin);
                    })
               );
          return result;
     }

     login(endpoint: string, body?: any, headers?: HttpHeaders): Observable<any> {
          var url = environment.baseGatewayURL + endpoint;
          if (!headers) {
               var headers = new HttpHeaders();
               headers = headers.append('Content-Type', 'application/json');
          }
          return this.http.post(url, body, { headers: headers, withCredentials: true }).pipe(tap((data) => { },
               (error) => {

               }));
     }

     public updateData(token, short_name, org_id, user_id, org_name, username, gvaAdmin) {
          this.token = token;
          this.short_name = short_name;
          this.orgId = org_id;
          this.org_name = org_name;
          this.user_id = user_id;
          this.errors = [];
          this.username = username;
          this.gvaAdmin = gvaAdmin ? gvaAdmin : false;
     }

     public storeAuthData(username: string, token: string, expiry: string, short_name: string, orgId: string, user_id: string, org_name: string, gvaAdmin) {
          const userData = {
               username: username,
               token: token,
               expirationDate: expiry,
               short_name: short_name,
               org_id: orgId,
               user_id: user_id,
               org_name: org_name,
               gvaAdmin: gvaAdmin
          };
          localStorage.setItem('user', JSON.stringify(userData));
     }

     autoLogin() {
          if (!localStorage.getItem('user')) {
               return of(null);
          }
          const userData = JSON.parse(localStorage.getItem('user'));
          const expirationDate = new Date(userData.expirationDate);
          if (expirationDate <= new Date()) {
               return of(null);
          } else {
               return of(true);
          }
     }

     signout(): Observable<any>  {
          localStorage.removeItem('user');
          localStorage.removeItem('userdata');
          localStorage.removeItem('caseData');
          localStorage.removeItem('Profile');
          this._user.next(null);
          this.router.navigate(['/']);
          const url = environment.baseGatewayURL + 'logout/';
          var headers = new HttpHeaders(); 
          headers = headers.append('Content-Type', 'application/json');
          return this.http.get(url,{headers: headers, withCredentials: true }).pipe(tap((data)=>{
          }, (error)=>{
          }));
     }

     sessionCleanup(param: HttpParams): Observable<any>  {
          localStorage.removeItem('user');
          localStorage.removeItem('userdata');
          localStorage.removeItem('caseData');
          localStorage.removeItem('Profile');
          this._user.next(null);
          const url = environment.baseGatewayURL + 'session-cleanup/';
          var headers = new HttpHeaders(); 
          headers = headers.append('Content-Type', 'application/json');
          return this.http.get(url, {headers: headers, params: param}).pipe(tap((data) => {
          }, 
          (error) => {
          }));
     }
     
     resetPassword(params: any): Observable<any> {
          var url = environment.baseGatewayURL + 'usermanagement/forgot_password/';
          return this.http.get(url, params).pipe(tap((data) => {

          }, (error) => {

          }));
     }

     updatePassword(params: any): Observable<any> {
          var url = environment.baseGatewayURL + 'usermanagement/update_password/';

          return this.http.post(url, params).pipe(tap((data) => {

          }, (error) => {

          }));
     }

     postRequestForTrial(body: RequestTrial ): Observable<string> {
          var headers = new HttpHeaders();
          headers = headers.append('Content-Type', 'application/json');
          return this.http.post(environment.baseGatewayURL+'usermanagement/requestfortrial/', body, {headers: headers})
          .pipe(tap((data: string) => {
               
          }, (error) => {
             
          }));
     }

     getRequestForTrial(email: string): Observable<RequestTrailConfirmAPI> {
          return this.http.get(environment.baseGatewayURL+'usermanagement/activate/'+email+'/')
          .pipe(tap((data:RequestTrailConfirmAPI) => {
          },
          (error) => {
            
          }));
     }

     activateRequestForTrial(body: any): Observable<string> {
          var headers = new HttpHeaders();
          headers = headers.append('Content-Type', 'application/json');
          return this.http.post(environment.baseGatewayURL+'usermanagement/password/', body, {headers: headers})
          .pipe(tap((data:string) => {               
          }, (error) => {

          }));
     }

}
